import React from 'react'
import styled from 'styled-components'
import { Breakpoints, Colors } from 'src/constants'

export const MigrationInterfaceContainer = styled.div`
  width: 600px;
  @media only screen and (max-width: ${Breakpoints.MOBILE}px) {
    min-width: 325px;
    max-width: 400px;
    padding: 0px 10px 0px 10px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE}px) {
    width: 500px;
  }

  @media only screen and (min-width: ${Breakpoints.TABLET_LANDSCAPE}px) {
    width: 600px;
  }
`

export const Overlay = styled.div`
  background: rgba(0, 0, 0, 1);
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 20px;
`

export const RecentTransactionsLinkA = styled.a`
  color: ${Colors.BLUE};
  font-size: 1em;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`

interface RecentTransactionProps {
  address: string
  chainId: number
}

export const RecentTransactions = (props: RecentTransactionProps) => {
  return (
    <RecentTransactionsLinkA
      target="_blank"
      rel="noopener noreferrer"
      href={`https://${
        props.chainId === 4 ? 'rinkeby.' : ''
      }etherscan.io/address/${props.address}`}
    >
      {'View recent transactions'}
    </RecentTransactionsLinkA>
  )
}
